<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Account Request</li>
    </ol>
  </nav>
  <div id="errorMessage2" class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="invalid-feedback d-block shift-invalid-text" *ngIf="statusMessage">{{statusMessage}}</div>
  <div class="row align-items-center">
    <div class="col">
      <ul class="list-inline tab-list deskContent">
        <li class="list-inline-item"><a (click)="populateTabData('all','ALL');tabChange(); checkedList=[];"
                                        [ngClass]="{'active': tabClicked === 'all'}">All</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('new','NEW');tabChange();checkedList=[];"
                                        [ngClass]="{'active': tabClicked === 'new'}">New</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('notified','NOTIFIED'); tabChange();checkedList=[];"
                                        [ngClass]="{'active': tabClicked === 'notified'}">Notified</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('approved','APPROVED');tabChange();checkedList=[];"
                                        [ngClass]="{'active': tabClicked === 'approved'}">Under Verification</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('Verified','Verified');tabChange();checkedList=[];"
                                        [ngClass]="{'active': tabClicked === 'Verified'}">Verified</a></li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;"
              data-value="All" required>
        <option value="ALL">All</option>
        <option value="NEW">New</option>
        <option value="NOTIFIED">Notified</option>
        <option value="APPROVED">Under Verification</option>
        <option value="Verified">Verified</option>
      </select>
    </div>
    <div class="col-6 text-right">
      <button data-toggle="dropdown" [hidden]="tabClicked === 'all'" aria-haspopup="true" aria-expanded="false"
              class="btn btn-outline-primary btn-sm dropdown-toggle ml-2" *ngIf="(checkedList?.length)">
        Actions
      </button>
      <a placement="bottom" ngbTooltip="Create" class="ml-2">
        <svg xmlns="http://www.w3.org/2000/svg" [hidden]="tabClicked === 'approved' || tabClicked === 'all'"
             routerLink="/admin/createAccountOwner" width="30" height="30" viewBox="0 0 30 30">
          <defs>
            <style>.a{fill:#8a55bb;}.b{fill:#fff;}</style>
          </defs>
          <g transform="translate(4 2.5)">
            <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
            <path class="b"
                  d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                  transform="translate(2.823 3.938)"/>
          </g>
        </svg>
      </a>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right" *ngIf="(checkedList?.length)">
        <a *ngIf="tabClicked !== 'approved'&& checkedList?.length!==1" (click)="checkWarehouse(warehouseRequest)"
           class="dropdown-item file btn shift-import">Process Request</a>
        <a *ngIf="tabClicked !== 'approved' && checkedList?.length===1" (click)="checkWarehouse(warehouseRequest)"
           data-toggle="modal" data-target="#warehouseDetails" class="dropdown-item file btn shift-import">Process
          Request</a>
        <a *ngIf="tabClicked == 'approved' && checkedList?.length===1" (click)="shipMultipleOrders(warehouseRequest)"
           class="dropdown-item file btn shift-import">Verify Documents</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th [hidden]="tabClicked === 'all' || tabClicked === 'Verified'">
            </th>
            <th>Company Name</th>
            <th>Owner Name</th>
            <th>Mobile Number</th>
            <th>Email Address</th>
            <th>Creation Date</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let w of warehouseRequest; let i = index;">
            <td [hidden]="tabClicked === 'all' || tabClicked === 'Verified'">
              <div class="form-checkbox"><input type="checkbox" id="{{i}}-{{w.warehouseReqId}}"
                                                [(ngModel)]="w.isSelected" name="list_name"
                                                (change)="selectShip(w)">
                <label for="{{i}}-{{w.warehouseReqId}}"></label></div>
            </td>
            <td class="shift-email-width">{{w.companyName}}</td>
            <td>{{w.ownerName}}</td>
            <td>{{w.mobile}}</td>
            <td class="shift-email-width">{{w.email}}</td>
            <td>{{w.createdDate}}</td>
            <td width="200px;" [hidden]="tabClicked !== 'approved'"><!--{{w.approvalStatus | titlecase}}-->
              {{((w?.mouUploaded == 'NO' && w?.panCardUploaded == 'NO' && w?.aadharCardUploaded == 'NO' ? 'Docs to be
              Uploaded' :
              (w?.mouUploaded == 'YES' && w?.panCardUploaded == 'NO' && w?.aadharCardUploaded == 'NO' ? 'MOU Uploaded' :
              (w?.mouUploaded == 'NO' && w?.panCardUploaded == 'YES' && w?.aadharCardUploaded == 'YES' ? 'KYC Uploaded'
              :
              (w?.mouUploaded == 'YES' && w?.panCardUploaded == 'YES' && w?.aadharCardUploaded == 'YES' ? 'Docs
              Uploaded' :
              w?.approvalStatus )))))| replaceStatus}}
            </td>
            <td [hidden]="tabClicked === 'approved'">{{w.approvalStatus | titlecase}}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="warehouseRequest?.length===0|| !warehouseRequest?.length">
            <td colspan="8" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th [hidden]="tabClicked === 'approved' || tabClicked === 'all'">
            </th>
            <th>Company Name</th>
            <th>Mobile Number</th>
            <th>Email Address</th>
            <th>Creation Date</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let w of warehouseRequest; let i = index;">
            <td [hidden]="tabClicked === 'approved' || tabClicked === 'all'">
              <div class="form-checkbox"><input type="checkbox" id="{{i}}-{{w.warehousesReqId}}"
                                                [(ngModel)]="w.isSelected" name="list_name"
                                                (change)="selectShip(w)"><label
                for="{{i}}-{{w.warehousesReqId}}"></label></div>
            </td>
            <td><label><b class=" tablesaw-cell-label">Company Name</b></label>
              <span class="tablesaw-cell-content">{{w.companyName}}</span></td>
            <td><label><b class=" tablesaw-cell-label">Mobile Number</b></label>
              <span class="tablesaw-cell-content">{{w.mobile}}</span></td>
            <td><label><b class=" tablesaw-cell-label">Email Address</b></label>
              <span class="tablesaw-cell-content">{{w.email}}</span></td>
            <td><b class=" tablesaw-cell-label">Creation Date</b>
              <span class="tablesaw-cell-content">{{w.createdDate}}</span></td>
            <td><label><b class=" tablesaw-cell-label">Status</b></label>
              <span class="tablesaw-cell-content">{{w.approvalStatus | titlecase}}</span></td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="warehouseRequest?.length===0|| !warehouseRequest?.length">
            <td colspan="8" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </div>
</section>

<!--Details model box-->
<div class="modal" id="warehouseDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div id="warehouseDetailsModal" [hidden]="step !== 1">
        <div class="modal-header border-0">
          <h2 class="modal-title">Account Information</h2>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
              <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
                <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                      stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
                <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                      stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              </g>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 col-xs-12 required">
              <div class="form-group required mt-1">
                <p for="warehouse" class="control-label shift-date mb-2">Company Name</p>
                <label>{{viewCustomer?.companyName}}</label>
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="form-group required mt-2">
                <p class="control-label shift-date mb-2" for="units">Owner Name</p>
                <label>{{viewCustomer?.ownerName}}</label>
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="form-group required mt-2">
                <p for="duration" class="control-label shift-date mb-2">Mobile</p>
                <label>{{viewCustomer?.mobile}}</label>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 required">
              <div class="form-group required mt-2">
                <p for="chargestype" class="control-label shift-date mb-2">Email</p>
                <label>{{viewCustomer?.email}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button class="btn btn-orange" [attr.data-dismiss]="approveDismissModal" (click)="submitApprove()"
                  data-toggle="modal" [attr.data-target]="approvePopup">
            <svg class="mr-1" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 width="20px" height="23px" viewBox="0 0 30 30" enable-background="new 0 0 28 28" xml:space="preserve">
              <g>
                <g>
                  <path fill="#ffff" d="M14,0C6.28,0,0,6.28,0,14s6.28,14,14,14s14-6.28,14-14C27.999,6.28,21.72,0,14,0z M14,25.743
                    c-6.475,0-11.743-5.268-11.743-11.744C2.257,7.524,7.525,2.256,14,2.256S25.743,7.525,25.743,14S20.475,25.743,14,25.743z"/>
                  <path fill="#ffff" d="M18.463,9.536l-6.535,6.535L9.537,13.68c-0.44-0.441-1.155-0.441-1.595,0c-0.441,0.44-0.441,1.155,0,1.595
                    l3.189,3.189c0.22,0.22,0.509,0.331,0.798,0.331s0.577-0.11,0.797-0.331l7.333-7.333c0.44-0.441,0.44-1.155,0-1.595
                    C19.617,9.095,18.904,9.095,18.463,9.536z"/>
                </g>
              </g>
            </svg>
            Approve
          </button>
          <button (click)="notifyConfirm()" type="button" class="btn btn-cancel ml-2" data-toggle="modal">
            <svg class="mr-1" version="1.1" fill="#686868" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 width="20px" height="23px" viewBox="0 0 30 30" enable-background="new 0 0 28 28" xml:space="preserve">
              <g>
                <path d="M14,0C6.268,0,0,6.268,0,14c0,7.732,6.268,14,14,14c7.732,0,14-6.267,14-14C28,6.268,21.732,0,14,0z M14,25.375
                  C7.718,25.375,2.625,20.282,2.625,14S7.718,2.625,14,2.625S25.375,7.718,25.375,14S20.282,25.375,14,25.375z M14.001,6.14
                  c-1.003,0-1.761,0.523-1.761,1.369v7.752c0,0.846,0.759,1.368,1.761,1.368c0.978,0,1.761-0.543,1.761-1.368V7.508
                  C15.762,6.683,14.979,6.14,14.001,6.14z M14.001,18.375c-0.963,0-1.747,0.784-1.747,1.748c0,0.962,0.784,1.747,1.747,1.747
                  s1.747-0.784,1.747-1.747C15.747,19.159,14.964,18.375,14.001,18.375z"/>
              </g>
            </svg>
            Notify
          </button>
        </div>
      </div>
      <div id="notifyDetailsModal" [hidden]="step !== 2">
        <div class="modal-header border-0">
          <h2 class="modal-title" id="exampleModalLabel1">Notify</h2>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
              <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
                <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                      stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
                <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                      stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              </g>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group required">
                <label class="control-label" for="type">Notification Type</label>
                <select id="type" class="form-control" [(ngModel)]="notification" [ngModelOptions]="{standalone: true}"
                        (change)="getNotificationMessage()" required>
                  <option *ngFor="let n of notificationTypes" [ngValue]="n.config">{{n.config}}</option>
                </select>

                <div id="statusText6" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText6">
                  {{statusText6}}
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <div class="" style="font-size:11px">
                <label for="notificationMessage">Notification Message/ Reason to Specify</label>
                <textarea id="notificationMessage" [(ngModel)]="message" rows="4" class="form-control"
                          [ngModelOptions]="{standalone: true}" required></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-cancel" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-orange ml-2" [attr.data-dismiss]="notifyDismissModal" data-toggle="modal"
                  (click)="submitNotify()" [attr.data-target]="notificationPopup">Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade style-modal" id="saveModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-img">
        <svg viewBox="0 0 60 60" width="80" xmlns="http://www.w3.org/2000/svg">
          <g id="Page-1" fill="none" fill-rule="evenodd">
            <g id="009---message-alert" fill="rgb(0,0,0)" fill-rule="nonzero" transform="translate(0 -1)">
              <path fill="#fff" id="Shape"
                    d="m59.975 21.81c-.0252119-.0879777-.0562813-.1741701-.093-.258-.0165345-.0342915-.0348942-.0676727-.055-.1-.009-.013-.01-.029-.019-.042s-.039-.031-.056-.051c-.0342726-.0402735-.0717265-.0777274-.112-.112-.02-.016-.029-.039-.05-.054l-14.208-10.384c-2.7840647-5.98497874-8.7868578-9.81173501-15.3876898-9.80958972-6.6008319.00214529-12.6011364 3.83280259-15.3813102 9.81958972l-14.203 10.373c-.021.016-.031.039-.051.056-.03970013.0341976-.07680243.0712999-.111.111-.017.02-.04.03-.056.051s-.01.028-.018.041c-.02056309.0322353-.03926046.0656235-.056.1-.0221803.0458712-.04089917.0933369-.056.142-.01473554.0378589-.02709291.076601-.037.116-.00585317.038408-.0091936.077157-.01.116 0 .026-.015.048-.015.074v34.001c.0026002 1.0569743.3431929 2.0854101.972 2.935.013.021.015.045.03.065s.054.04.078.066c.93831391 1.2149146 2.38493592 1.9286307 3.92 1.934h50c1.5350641-.0053693 2.9816861-.7190854 3.92-1.934.024-.026.057-.037.078-.066s.017-.044.03-.065c.6288071-.8495899.9693998-1.8780257.972-2.935v-34c0-.026-.013-.048-.015-.074-.0008483-.0388408-.0041885-.0775871-.01-.116zm-1.975 34.19c-.0040922.3120758-.0574149.6215501-.158.917l-22.469-16.417 22.627-16.531zm-55.842.917c-.10058511-.2954499-.15390784-.6049242-.158-.917v-32.031l22.627 16.531zm1.906-33.917h9.689c2.1961004 7.1310199 8.7854786 11.9965021 16.247 11.9965021s14.0508996-4.8654822 16.247-11.9965021h9.689l-23.667 17.289c-1.358139.9387072-3.1540696.9442723-4.518.014zm51.874-2h-9.219c.4278862-2.2765162.3665279-4.6180181-.18-6.869zm-25.938-18c8.2842712 0 15 6.71572875 15 15 0 8.2842712-6.7157288 15-15 15s-15-6.7157288-15-15c.0093685-8.28038757 6.7196124-14.99063148 15-15zm-16.719 18h-9.216l9.394-6.862c-.5446808 2.2489086-.6053535 4.5878769-.178 6.862zm-8.281 38c-.58034452-.0004564-1.14791851-.1704158-1.633-.489l22.956-16.774.268.2c.9990958.6908994 2.185285 1.0603624 3.4 1.059 1.2279919.0003388 2.4267976-.3743752 3.436-1.074l.248-.181 22.958 16.77c-.4850815.3185842-1.0526555.4885436-1.633.489z"/>
              <path fill="#fff" id="Shape"
                    d="m5 29c-.55228475 0-1 .4477153-1 1v10c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-10c0-.5522847-.44771525-1-1-1z"/>
              <path fill="#fff" id="Shape"
                    d="m5 43c-.55228475 0-1 .4477153-1 1v3c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-3c0-.5522847-.44771525-1-1-1z"/>
              <path fill="#fff" id="Shape"
                    d="m22 26h4c0 2.209139 1.790861 4 4 4s4-1.790861 4-4h4c.5522847 0 1-.4477153 1-1v-2c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-5.184c-.0031107-2.732017-1.5953871-5.21257906-4.078-6.353.2802069-1.20469622-.2076506-2.45787802-1.2286269-3.15603002-1.0209764-.69815201-2.3657698-.69815201-3.3867462 0-1.0209763.698152-1.5088338 1.9513338-1.2286269 3.15603002-2.4826129 1.14042094-4.0748893 3.620983-4.078 6.353v5.184c-1.1943509.4222546-1.9947486 1.5492146-2 2.816v2c0 .5522847.4477153 1 1 1zm8 2c-1.1045695 0-2-.8954305-2-2h4c0 1.1045695-.8954305 2-2 2zm-1-20c0-.55228475.4477153-1 1-1s1 .44771525 1 1c0 .028-.01.051-.012.078-.6545662-.10393871-1.3214338-.10393871-1.976 0-.002-.027-.012-.05-.012-.078zm-4 7c0-2.7614237 2.2385763-5 5-5s5 2.2385763 5 5v5h-10zm-2 8c0-.5522847.4477153-1 1-1h12c.5522847 0 1 .4477153 1 1v1h-14z"/>
            </g>
          </g>
        </svg>
      </div>
      <div class="modal-body">
        <h1 class="mb-3">Notification Confirmation</h1>
        <p class="mb-5">Details Sent to Customer Email </p>
        <div class="text-right">
          <button type="button" class="btn btn-optional" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Approved model box-->
<div class="modal fade style-modal" id="approveModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-img">
        <svg viewBox="0 0 60 60" width="80" xmlns="http://www.w3.org/2000/svg">
          <g id="Page-1" fill="none" fill-rule="evenodd">
            <g id="009-&#45;&#45;message-alert" fill="rgb(0,0,0)" fill-rule="nonzero" transform="translate(0 -1)">
              <path fill="#fff" id="Shape"
                    d="m59.975 21.81c-.0252119-.0879777-.0562813-.1741701-.093-.258-.0165345-.0342915-.0348942-.0676727-.055-.1-.009-.013-.01-.029-.019-.042s-.039-.031-.056-.051c-.0342726-.0402735-.0717265-.0777274-.112-.112-.02-.016-.029-.039-.05-.054l-14.208-10.384c-2.7840647-5.98497874-8.7868578-9.81173501-15.3876898-9.80958972-6.6008319.00214529-12.6011364 3.83280259-15.3813102 9.81958972l-14.203 10.373c-.021.016-.031.039-.051.056-.03970013.0341976-.07680243.0712999-.111.111-.017.02-.04.03-.056.051s-.01.028-.018.041c-.02056309.0322353-.03926046.0656235-.056.1-.0221803.0458712-.04089917.0933369-.056.142-.01473554.0378589-.02709291.076601-.037.116-.00585317.038408-.0091936.077157-.01.116 0 .026-.015.048-.015.074v34.001c.0026002 1.0569743.3431929 2.0854101.972 2.935.013.021.015.045.03.065s.054.04.078.066c.93831391 1.2149146 2.38493592 1.9286307 3.92 1.934h50c1.5350641-.0053693 2.9816861-.7190854 3.92-1.934.024-.026.057-.037.078-.066s.017-.044.03-.065c.6288071-.8495899.9693998-1.8780257.972-2.935v-34c0-.026-.013-.048-.015-.074-.0008483-.0388408-.0041885-.0775871-.01-.116zm-1.975 34.19c-.0040922.3120758-.0574149.6215501-.158.917l-22.469-16.417 22.627-16.531zm-55.842.917c-.10058511-.2954499-.15390784-.6049242-.158-.917v-32.031l22.627 16.531zm1.906-33.917h9.689c2.1961004 7.1310199 8.7854786 11.9965021 16.247 11.9965021s14.0508996-4.8654822 16.247-11.9965021h9.689l-23.667 17.289c-1.358139.9387072-3.1540696.9442723-4.518.014zm51.874-2h-9.219c.4278862-2.2765162.3665279-4.6180181-.18-6.869zm-25.938-18c8.2842712 0 15 6.71572875 15 15 0 8.2842712-6.7157288 15-15 15s-15-6.7157288-15-15c.0093685-8.28038757 6.7196124-14.99063148 15-15zm-16.719 18h-9.216l9.394-6.862c-.5446808 2.2489086-.6053535 4.5878769-.178 6.862zm-8.281 38c-.58034452-.0004564-1.14791851-.1704158-1.633-.489l22.956-16.774.268.2c.9990958.6908994 2.185285 1.0603624 3.4 1.059 1.2279919.0003388 2.4267976-.3743752 3.436-1.074l.248-.181 22.958 16.77c-.4850815.3185842-1.0526555.4885436-1.633.489z"/>
              <path fill="#fff" id="Shape"
                    d="m5 29c-.55228475 0-1 .4477153-1 1v10c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-10c0-.5522847-.44771525-1-1-1z"/>
              <path fill="#fff" id="Shape"
                    d="m5 43c-.55228475 0-1 .4477153-1 1v3c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-3c0-.5522847-.44771525-1-1-1z"/>
              <path fill="#fff" id="Shape"
                    d="m22 26h4c0 2.209139 1.790861 4 4 4s4-1.790861 4-4h4c.5522847 0 1-.4477153 1-1v-2c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-5.184c-.0031107-2.732017-1.5953871-5.21257906-4.078-6.353.2802069-1.20469622-.2076506-2.45787802-1.2286269-3.15603002-1.0209764-.69815201-2.3657698-.69815201-3.3867462 0-1.0209763.698152-1.5088338 1.9513338-1.2286269 3.15603002-2.4826129 1.14042094-4.0748893 3.620983-4.078 6.353v5.184c-1.1943509.4222546-1.9947486 1.5492146-2 2.816v2c0 .5522847.4477153 1 1 1zm8 2c-1.1045695 0-2-.8954305-2-2h4c0 1.1045695-.8954305 2-2 2zm-1-20c0-.55228475.4477153-1 1-1s1 .44771525 1 1c0 .028-.01.051-.012.078-.6545662-.10393871-1.3214338-.10393871-1.976 0-.002-.027-.012-.05-.012-.078zm-4 7c0-2.7614237 2.2385763-5 5-5s5 2.2385763 5 5v5h-10zm-2 8c0-.5522847.4477153-1 1-1h12c.5522847 0 1 .4477153 1 1v1h-14z"/>
            </g>
          </g>
        </svg>
      </div>
      <div class="modal-body">
        <h1 class="mb-3">Request Approved.</h1>
        <p class="mb-5">Customer will receive an email with the same.</p>
        <div class="text-right">
          <button type="button" class="btn btn-optional" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
